<template>
<v-container xs12>
    <v-layout row>
      <v-flex xs12 >
        <h4 class="primary--text">Nieuwe Offerte Aanmaken</h4>
      </v-flex>
    </v-layout>
   
      
        <form @submit.prevent="onCreateOfferte">
       <v-data-iterator
            :items="questions"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
         
        >
            <v-flex
                align-start
                slot="item"
                slot-scope="qs"
            >
             <v-layout align-start>
              <v-flex sm12
                 v-if        ="qs.item.type == 'picture'">
              <v-btn raised 
                v-if        ="qs.item.type == 'picture'"
                @click="onPickFile(qs.item.targetField)"
                >{{ qs.item.label }}
                </v-btn>
                <input 
                    type        ="file" 
                    accept      ="image/*"
                    style       ="display:none"
                    :name       ="qs.item.targetField"
                    :id         ="qs.item.targetField" 
                    :required   ="qs.item.required"
                    :ref        ="qs.item.targetField"
                    @change     ="onFilePicked()"
                />
                 <img :src="bid['preview-'+qs.item.targetField]" height="150">
            </v-flex>
            
              <v-text-field 
                v-if        ="qs.item.type == 'text'"
                xs12
                :name       ="qs.item.targetField"
                :label      ="qs.item.label"
                :id         ="qs.item.targetField"
                v-model     ="bid[qs.item.targetField]"
                :required   ="qs.item.required"
                >
                </v-text-field>
              <v-slider 
                v-if="qs.item.type == 'slider'"
                xs10
                :name       ="qs.item.targetField"
                :label      ="qs.item.label"
                :id         ="qs.item.targetField"
                v-model     ="bid[qs.item.targetField]"
                :required   ="qs.item.required"
                :max        ="qs.item.maxValue"
                :min        ="qs.item.minValue"
                :step       ="qs.item.step"
                ></v-slider>
                <v-spacer></v-spacer>
                <v-text-field  
                    v-if="qs.item.type == 'slider'"
                    v-model="bid[qs.item.targetField]" 
                    :label="qs.item.unitLabel"
                    xs2
                ></v-text-field>
                
            
            
                <v-radio-group xs12
                    v-model="bid[qs.item.targetField]" 
                    v-if="qs.item.type == 'radiobutton'"
                    :label="qs.item.label"
                    align-start
                >
                    <v-radio
                        v-for="option in qs.item.values" 
                        :key="option.id"
                        :value="option.id"
                        :label="option.label"         
                    ></v-radio>
                </v-radio-group>
            
              <v-switch
                v-if="qs.item.type == 'switch'"
                xs12
                :name       ="qs.item.targetField"
                :label      ="qs.item.label"
                :id         ="qs.item.targetField"
                v-model     ="bid[qs.item.targetField]"
                >
                </v-switch>
                
            <v-select
                v-if="qs.item.type == 'multi'"
                v-model="bid[qs.item.targetField]"
                :items="qs.item.values"
                item-text="label"
                item-value="id"
                chips
                :label="qs.item.label"
                multiple
                solo
            ></v-select>
            
        </v-layout>
        </v-flex>
        <v-layout row slot="footer">
            <v-flex xs12 >
                <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit">Opslaan</v-btn>
            </v-flex>
        </v-layout>
    </v-data-iterator>
    
    </form>

  </v-container>
</template>
<script>
    export default {
        props: ['id'],
        data() {
            return{
                
                rowsPerPageItems: [10,20,50],
                pagination: {
                    rowsPerPage: 20
                }
                
            }
        },
        computed:{
            formIsValid() {
                return this.customerName !== '' && this.power !== '';
            },
            questions(){
                return this.$store.getters.questions;
            },
            bid()
            {
                if(this.$route.params.id)
                {
                    //a bid was loaded
                     return this.$store.getters.loadedOfferte(this.$route.params.id);
                }
                else
                {
                    return {}
                }
            }
        },
        methods :{
            onCreateOfferte(){
                var bid = {};
                const questions = this.$store.getters.questions;
                for (var questionid in questions) {
                    //only store fields that are filled in
                    if(this.bid[questions[questionid]["targetField"]])
                    {
                        bid[questions[questionid]["targetField"]] = this.bid[questions[questionid]["targetField"]] ;
                    }
                    
                }
                const payload = {
                    bid : {...bid,dateCreated : new Date()},
                    router : this.$router
                }
                this.$store.dispatch('createOfferte',payload);
               //this.$router.push('/offerte/');
            },
            onPickFile(refid){
                this.$refs[refid].click();
            },
            onFilePicked(){
                const files = event.target.files;
                //only get first file, currently doesn't allow multiple
                let filename = files[0].name;
                if(filename.lastIndexOf('.') <= 0)
                {
                    return alert("Please add a valid file (no extension).");
                }
                var fileReader = new FileReader();
                fileReader["preview_target"] = "preview-"+event.target.id;
                fileReader.addEventListener('load',() =>{
                    this.bid[fileReader.preview_target] = fileReader.result;
                })
                fileReader.readAsDataURL(files[0]);
                this.bid[event.target.id] = files[0];
            }
        }
    }
</script>
